import { API_BASE_URL } from '../../config'
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT } from './authActionTypes'

export const login = (username, password) => async dispatch => {
  dispatch({ type: LOGIN_REQUEST })
  try {
    const res = await fetch(`${API_BASE_URL}/auth/login/`, {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({ username, password })
    })

    if (!res.ok) throw new Error('Invalid credentials or network error')

    const data = await res.json()
    if (data.key) {
      localStorage.setItem('auth_token', data.key)
      dispatch({ type: LOGIN_SUCCESS, payload: data })
      return { success: true }
    } else {
      throw new Error('No token returned')
    }
  } catch (error) {
    dispatch({ type: LOGIN_FAILURE, error: error.message })
    return { success: false, error: error.message }
  }
}

export const logout = () => {
  localStorage.removeItem('auth_token')
  return { type: LOGOUT }
}

export const checkAuth = () => (dispatch, getState) => {
  const token = localStorage.getItem('auth_token')
  return !!token
}

export const changePassword = (oldPassword, newPassword) => async () => {
  const token = localStorage.getItem('auth_token')
  try {
    const res = await fetch(`${API_BASE_URL}/auth/password/change/`, {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`,
      },
      credentials: 'include',
      body: JSON.stringify({
        old_password: oldPassword,
        new_password1: newPassword,
        new_password2: newPassword,
      }),
    })
    const data = await res.json().catch(() => ({}))
    if (!res.ok) {
      const message = data.old_password?.[0] || data.new_password1?.[0] || data.new_password2?.[0] || data.detail || 'Failed to change password'
      throw new Error(message)
    }
    return { success: true }
  } catch (error) {
    return { success: false, error: error.message || 'Failed to change password' }
  }
}
